<article class="atmos-privacy">
  <header class="atmos-page__header atmos-privacy__header">
    <h1 class="atmos-page__title">Privacy Policy</h1>
    <p class="atmos-privacy__meta">
      <span>Last Updated: October 22nd, 2025</span>
      <span class="atmos-privacy__meta-sep" aria-hidden="true">·</span>
      <span>Effective: October 22nd, 2025</span>
    </p>
  </header>

  <div class="atmos-card atmos-privacy__card">
    <div class="atmos-card__body atmos-privacy__body">
      <p class="atmos-privacy__lede">
        Welcome to Sky Planner (the "Website"). We value your privacy and want to be transparent about the data we
        collect, how we use it, and your rights regarding that information. This privacy policy outlines our practices
        related to the collection, use, and disclosure of information when you use our Website.
      </p>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">1. Information We Collect</h2>
        <p>
          The Website does not collect any personal data from its users. All data related to your game progress is stored
          locally in your browser's localStorage and is accessible only by you.
        </p>
        <p>
          Some pages of the Website allow you to submit data and make it available to other users. In these instances,
          your IP address may be logged to prevent abuse and a randomly generated token is stored alongside the submitted
          data to allow you to manage your submissions. This token is unidentifiable and cannot be used to track you.
        </p>
        <p>
          Some pages of the Website require you to authenticate through Discord instead. In these instances the Website
          exclusively uses your Discord User ID and username; no other data is collected or stored.
        </p>
        <p>
          All code of the Website, client-side and server-side, is open-source and can be reviewed on the
          <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner" target="_blank" rel="noopener">official Sky Planner GitHub repository</a>.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">2. Data Storage and Security</h2>
        <p>
          Your game progress data is stored locally in your browser's storage. Additionally, you have the option to
          connect the Website to your Dropbox account to save your progress. When you choose to save your progress to
          Dropbox, your data is stored privately in your personal Dropbox account. Please review Dropbox's privacy policy
          for more information on their data handling practices:
          <a class="atmos-text-link" href="https://www.dropbox.com/privacy" target="_blank" rel="noopener">Dropbox Privacy Policy</a>.
        </p>
        <p>
          You are responsible for backing up your data. While the Website accesses your data locally within your browser
          to provide its functionality, this progress data never leaves your device or your personal Dropbox account.
          Only you have access to this data, and therefore we cannot help you recover any lost data.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">3. Third-Party Services</h2>
        <p>
          The Website uses Cloudflare Web Analytics to gain insights into website usage. This service does not track
          individual users and only provides aggregate data about page visits to help prioritize development. For more
          information, please refer to Cloudflare's web analytics privacy information:
          <a class="atmos-text-link" href="https://www.cloudflare.com/web-analytics/" target="_blank" rel="noopener">Cloudflare Web Analytics</a>.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">4. Cookies and Tracking Technologies</h2>
        <p>
          The Website does not use cookies. We use localStorage to store your game progress data. LocalStorage is a type
          of web storage that allows websites to store data in your browser. This data is only accessible by you and
          remains on your device unless you choose to clear it. Do note that any third party extensions or plugins you
          have installed in your browser may be able to access this data. Read more about web storage on
          <a class="atmos-text-link" href="https://developer.mozilla.org/en-US/docs/Web/API/Web_Storage_API" target="_blank" rel="noopener">MDN Web Docs: Web Storage API</a>.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">5. User Rights</h2>
        <p>
          Since we do not collect any personal data, there are no personal data records for you to access, correct, or
          delete. Your game progress data is fully within your control, and you can manage it through your browser's
          storage settings or through your Dropbox account if you have opted to connect to Dropbox.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">6. Changes to This Privacy Policy</h2>
        <p>
          Although very unlikely, we may update this privacy policy from time to time. We will notify you of any changes
          by posting the new privacy policy on this page. You are advised to review this privacy policy periodically for
          any changes. Changes to this privacy policy are effective according to the date at the top of the page.
        </p>
      </section>

      <section class="atmos-privacy__section">
        <h2 class="atmos-privacy__section-title">7. Contact Us</h2>
        <p>If you have any questions or concerns about this privacy policy or our data practices, please contact us at:</p>
        <p>
          Email: <a class="atmos-text-link" href="mailto:support@sky-planner.com">support&#64;sky-planner.com</a><br/>
          Website: <a class="atmos-text-link" href="https://github.com/Silverfeelin/SkyGame-Planner/" target="_blank" rel="noopener">https://github.com/Silverfeelin/SkyGame-Planner/</a>
        </p>
        <p>Thank you for using Sky Planner!</p>
      </section>
    </div>
  </div>
</article>
